// extracted by mini-css-extract-plugin
export var banner = "_jb-0";
export var closeButton = "_jb-2";
export var greenCheckmark = "_jb-3";
export var hereLink = "_jb-4";
export var titleIcon = "_jb-1";